// extracted by mini-css-extract-plugin
export default {"modalOverlay":"sF-z","modalContent":"tF-z","header":"uF-z","close":"vF-z"};